// =============================================================================
// SIMPLE BASE64 ENCODED SESSION STORAGE
// =============================================================================

import Moment from 'moment';

// Simple Base64 encoding
const encryptData = (data) => {
  if (!data) return '';
  try {
    return btoa(data); // Convert to Base64 encoded string
  } catch (e) {

    return '';
  }
};

// Simple Base64 decoding
const decryptData = (encodedData) => {
  if (!encodedData) return '';
  try {
    return atob(encodedData); // Decode Base64 encoded string
  } catch (e) {

    return '';
  }
};

// =============================================================================
// SESSION FUNCTIONS
// =============================================================================

// Get user data
export const getUser = () => {
  try {
    const encoded = sessionStorage.getItem('_u');
    if (encoded) {
      const decoded = decryptData(encoded);
      return decoded ? JSON.parse(decoded) : null;
    }
  } catch (e) {

  }
  return null;
};

// Get token
export const getToken = () => {
  try {
    const encoded = sessionStorage.getItem('_t');
    if (encoded) {
      return decryptData(encoded);
    }
  } catch (e) {

  }
  return null;
};

export const getTokenAxios = () => {
  return getToken();
};

// Set session (Base64 encoded)
export const setUserSession = (token, user) => {
  try {
    // Encode and store
    sessionStorage.setItem('_t', encryptData(token));
    sessionStorage.setItem('_u', encryptData(JSON.stringify(user)));
    
    // Clean old data
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch (e) {

  }
};

// Remove session
export const removeUserSession = () => {
  sessionStorage.removeItem('_t');
  sessionStorage.removeItem('_u');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const formatDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return '';
  const start = Moment(startDate);
  const end = Moment(endDate);
  
  if (start.year() === end.year()) {
    if (start.month() === end.month()) {
      return `${start.format('DD')} - ${end.format('DD MMM YYYY')}`;
    }
    return `${start.format('DD MMM')} - ${end.format('DD MMM YYYY')}`;
  }
  return `${start.format('DD MMM YYYY')} - ${end.format('DD MMM YYYY')}`;
};
